import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
  fetchObject: ['object_id'],
  fetchObjectSuccess: ['responseData'],
  fetchObjectFailure: ['error'],

  fetchBoatTypes: null,
  fetchBoatTypesSuccess: ['responseData'],
  fetchBoatTypesFailure: ['error'],

  fetchJettyTypes: null,
  fetchJettyTypesSuccess: ['responseData'],
  fetchJettyTypesFailure: ['error'],

  fetchDriveTypes: null,
  fetchDriveTypesSuccess: ['responseData'],
  fetchDriveTypesFailure: ['error'],

  updateObject: ['payload', 'history'],
  updateObjectSuccess: ['responseData'],
  updateObjectFailure: ['error'],

  saveObject: ['payload'],

  selectObject: ['objectType', 'objectName'],
  
}, {});
